// Select the target element
const targetElement = document.querySelector('.product-info__block-item[data-block-type="konfigurator-offer"] .product-info__offer-list .text-with-icon');

// Create a function to handle the event when innerHTML changes
function onInnerHTMLChange(mutationsList) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const event = new CustomEvent('innerHTMLChanged', {
                detail: { newContent: targetElement.innerHTML }
            });
            targetElement.dispatchEvent(event);
        }
    }
}

// Create a MutationObserver instance
const observer = new MutationObserver(onInnerHTMLChange);

// Set up the observer configuration
const config = { childList: true, subtree: true, characterData: true };

observer.observe(targetElement, config);

targetElement.addEventListener('innerHTMLChanged', (e) => {
    var variant_picker_selected_options = document.querySelectorAll('variant-picker fieldset .variant-picker__option-values input:checked');
    var selected_options = {};
    variant_picker_selected_options.forEach(function (option) {
        const label = option.getAttribute('option_label_value');
        const value = option.getAttribute('option_value_name');
        if (label) {
            selected_options[label] = value;
        }
    });
    var cl_po_selected_options = document.querySelectorAll('.product-info__block-item div[data-live-options] .cl-po--wrapper .cl-po--options .cl-po--option .cl-po--swatch-container .cl-po--input:checked');
    cl_po_selected_options.forEach(function (option) {
        var label = option.getAttribute('name');
        label = label.replace('properties[', '');
        label = label.replace(']', '');
        const value = option.getAttribute('value');
        if (label) {
            selected_options[label] = value;
        }
    });

    const idMatches = {};

    // Loop through specificInputsArray to find matches
    specificInputsArray.forEach(specificInput => {
        // Check if the current specificInput matches the selected_options (excluding `id`)
        const allMatch = Object.keys(specificInput).every(key => {
            if (key === 'id') {
                return true; // Skip `id` in comparison
            }
            console.log(key, specificInput[key], selected_options[key]);
            return specificInput[key] === selected_options[key];
        });

        const id = specificInput.id;
        if (!idMatches[id]) {
            idMatches[id] = false; // Initialize as false
        }
        if (allMatch) {
            idMatches[id] = true; // Set to true if any match is found
        }
    });
    Object.keys(idMatches).forEach(id => {
        const element = document.getElementById(id);
        if (element) {
            element.style.display = idMatches[id] ? 'block' : 'none';
        }
    });
});

/*
window.addEventListener('option:changed', function(e) {

  // e.detail contains the option reference
  var option = e.detail;

  console.log(option);

  // print the option to the console
  console.debug('option changed', option);

  // check if the option is the one we want
  if(option.name == 'NAME_HERE'){
      // check if the value is the one we want
      if(option.value == 'VALUE_HERE'){
        // do something
      }
   }

});
window.addEventListener('options:rendered', function(e) {
    console.log('options rendered event detected');
     var optionEl = document.querySelector('[data-option="Felgenhoehe Vorderrad (GCX Terra)"]');
        if(optionEl){
            console.log('option element found', optionEl);
            // do something with optionEl
        } else {
            console.log('option element not found');
        }
});
*/

let productOptions;
window.addEventListener('options:rendered', function(e) {
   // store in global var
   productOptions = e.detail;
   console.log('RENDERED');

  // PRIVATE API TO GET FULL OPTION GROUPS
  var options = productOptions.config.options;

  for(let i=0; i < options.length; i++){
        var optionGroup = options[i];
        if(optionGroup.visible){
            if(optionGroup.label == 'Modell Vorderrad'){
                var current_value = optionGroup.value;
                var valueObj = optionGroup.values.find(v => v.value == current_value);
                if(valueObj){
                    var Vorderrad_weight = valueObj.weight * 1000;
                    var weightEl = document.querySelector('[data-confi-modell-vorderrad-weight]');
                    if(weightEl){
                        weightEl.innerHTML = Vorderrad_weight + ' g';
                        document.cookie = "vorderrad_weight=" + Vorderrad_weight + "; path=/";
                    }
                }
            } else if(optionGroup.label == 'Modell Hinterrad'){
                var current_value = optionGroup.value;
                var valueObj = optionGroup.values.find(v => v.value == current_value);
                if(valueObj){
                    var Hinterrad_weight = valueObj.weight * 1000;
                    var weightEl = document.querySelector('[data-confi-modell-hinterrad-weight]');
                    if(weightEl){
                        weightEl.innerHTML = Hinterrad_weight + ' g';
                        document.cookie = "hinterrad_weight=" + Hinterrad_weight + "; path=/";
                    }
                }
            } else if(optionGroup.label == 'Nabe'){
                var current_value = optionGroup.value;
                var valueObj = optionGroup.values.find(v => v.value == current_value);
                if(valueObj){
                    var Nabe_weight = valueObj.weight * 1000;
                    var weightEl = document.querySelector('[data-confi-nabe-weight]');
                    if(weightEl){
                        weightEl.innerHTML = Nabe_weight + ' g';
                        document.cookie = "nabe_weight=" + Nabe_weight + "; path=/";
                    }
                    var Nabe_name = valueObj.value;
                    var nameEl = document.querySelector('[data-confi-hub-name]');
                    if(nameEl){
                        nameEl.innerHTML = Nabe_name;
                        document.cookie = "nabe_name=" + Nabe_name + "; path=/";
                    }
                }
            }  else if(optionGroup.label == 'Speichen'){
                var current_value = optionGroup.value;
                var valueObj = optionGroup.values.find(v => v.value == current_value);
                if(valueObj){
                    var Speichen_name = valueObj.value;
                    var nameEl = document.querySelector('[data-confi-speichen]');
                    if(nameEl){
                        nameEl.innerHTML = Speichen_name;
                        document.cookie = "speichen_name=" + Speichen_name + "; path=/";
                    }
                }
            }
        }

  }
});

window.addEventListener('option:changed', function(e) {

});